import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { catchError, map, Observable, of, take } from 'rxjs';
import { PageUtils } from '../common/page.utils';
import { ErrorMessages } from '../constants/error-messages';
import { AssessApiService } from '../services/assess-api.service';
import {Store} from "@ngrx/store";
import { CampaignSettingsState } from "../store/models/assessment-models";
import {setCampaignSettings} from "../store/actions/campaign.actions";
import { LoggingService } from '../services/logging.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrationGuard implements CanActivate {
  constructor(
    private assessApiService: AssessApiService,
    private pageUtils: PageUtils,
    private campaignSettingStore: Store<CampaignSettingsState>,
    private logger: LoggingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const routeParams = this.pageUtils.getLandingRoutePathParameters(route);

    return this.assessApiService
      .getCampaignConfiguration(routeParams.orgCode, routeParams.campaignCode)
      .pipe(
        take(1),
        map((settings) => {
          this.campaignSettingStore.dispatch(
            setCampaignSettings({ showExternalIdField: settings.showExternalId }),
          );
          if (settings != null && settings.showLandingPage) {
            return true;
          } else {
            this.pageUtils.navigateToErrorPage(
              ErrorMessages.selfRegistrationNotConfigured,
            );
            return false;
          }
        }),
        catchError((err: HttpErrorResponse) => {
          this.logger.logException(err, 3);
          this.pageUtils.navigateToErrorPage(
            ErrorMessages.registrationRequestError,
          );
          return of(false);
        }),
      );
  }
}
